// CustomerRoot.jsx
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useState } from "react";
import Cookies from "js-cookie";
import logo from '../../icons/ABIS_logo.png';

export default function CustomerRoot() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  const navigate = useNavigate();

  // Hide header and sidebar on login page
  const isLoginPage =
    location.pathname === "/customer/login" || location.pathname === "/login";

  const navigation = [
    {
      name: "Dashboard",
      href: "/customer/dashboard",
      icon: (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      ),
    },
    // {
    //   name: 'Payment Details',
    //   href: '/customer/payment-details',
    //   icon: (
    //     <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
    //     </svg>
    //   )
    // },
    // {
    //   name: 'Estimation Page',
    //   href: '/customer/estimation',
    //   icon: (
    //     <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
    //     </svg>
    //   )
    // },
    {
      name: "KYC Details",
      href: "/customer/kyc-details",
      icon: (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
          />
        </svg>
      ),
    },
  ];

  const isActive = (href) => location.pathname === href;

  const handleLogout = () => {
    localStorage.clear();
    Cookies.remove("authToken", { path: "/" });
    navigate("/customer/login");
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* AppBar - Hidden on login page */}
      {!isLoginPage && (
        <div className="fixed top-0 left-0 right-0 z-50 bg-emerald-600 shadow-md">
          <div className="flex items-center justify-between px-4 h-16">
            <button
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="p-2 rounded-full hover:bg-emerald-700 transition-colors duration-200"
            >
              <svg
                className="w-6 h-6 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>

            <div className="flex-grow"></div>
{/* 
            <div className="flex items-center space-x-2">
              <div className="relative">
                <button className="p-2 rounded-full hover:bg-emerald-700 transition-colors duration-200 text-white relative">
                  <svg
                    className="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M15 17h5l-5 5v-5zM12 17.5a6.5 6.5 0 100-13 6.5 6.5 0 000 13z"
                    />
                  </svg>
                  <span className="absolute top-0.5 right-0.5 w-4 h-4 bg-red-500 rounded-full flex items-center justify-center text-xs text-white font-bold">
                    3
                  </span>
                </button>
              </div>
            </div> */}
          </div>
        </div>
      )}

      <div className="flex">
        {/* Drawer Backdrop - Hidden on login page */}
        {!isLoginPage && sidebarOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        {/* Sidebar - Hidden on login page */}
        {!isLoginPage && (
          <div
            className={`fixed top-0 left-0 h-full z-50 transform transition-transform duration-300 ease-in-out ${
              sidebarOpen ? "translate-x-0" : "-translate-x-full"
            }`}
            style={{ width: "280px", zIndex: 1200 }}
          >
            <div className="h-full bg-white flex flex-col shadow-xl">
              {/* Header */}
              <div className="bg-gradient-to-r from-emerald-600 to-emerald-700 flex items-center justify-between p-4">
                <div className="flex flex-col">
                  <div className="bg-white rounded-lg p-1.5 w-fit">
                    <div className="w-10 h-10 bg-gradient-to-r from-emerald-500 to-emerald-600 rounded-md flex items-center justify-center text-white font-bold">
                      <img src={logo} alt="abis_logo" />
                    </div>
                  </div>
                  {/* <p className="mt-1.5 text-xs font-semibold italic text-white">
                    Your Trusted Partner
                  </p> */}
                </div>

                <button
                  onClick={() => setSidebarOpen(false)}
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-white bg-opacity-10 hover:bg-opacity-20 transition-all duration-200"
                >
                  <svg
                    className="w-4 h-4 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>

              {/* Menu Items */}
              <div className="px-3 flex-grow overflow-y-auto">
                <p className="uppercase text-xs font-semibold tracking-wider text-gray-400 px-2 mb-1.5 mt-4">
                  MAIN MENU aa
                </p>

                <div className="mt-1.5 space-y-1">
                  {navigation.map((item) => {
                    const active = isActive(item.href);

                    return (
                      <Link
                        key={item.name}
                        to={item.href}
                        className={`rounded-lg py-3 px-3 flex items-center cursor-pointer transition-all duration-200 
                         ${
                           active
                             ? "bg-emerald-50 border-l-4 border-emerald-500"
                             : "hover:bg-gray-50 border-l-4 border-transparent"
                         }`}
                        onClick={() => setSidebarOpen(false)}
                      >
                        <div
                          className={`min-w-10 ${
                            active ? "text-emerald-600" : "text-gray-400"
                          }`}
                        >
                          {item.icon}
                        </div>
                        <span
                          className={`text-sm font-medium ${
                            active ? "text-emerald-700" : "text-gray-700"
                          }`}
                        >
                          {item.name}
                        </span>
                        {active && (
                          <div className="ml-auto">
                            <div className="w-2 h-2 bg-emerald-500 rounded-full"></div>
                          </div>
                        )}
                      </Link>
                    );
                  })}
                </div>
              </div>

              {/* Divider */}
              {/* <div className="px-4 my-2">
                <div className="h-px bg-gray-200"></div>
              </div> */}

              {/* User Profile */}
              {/* <div className="p-3 mx-3 mb-4 flex items-center bg-emerald-50 hover:bg-emerald-100 rounded-lg cursor-pointer transition-all duration-200">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-emerald-400 to-emerald-600 flex items-center justify-center text-white font-medium shadow-lg">
                  U
                </div>
                <div className="ml-3 flex-grow">
                  <p className="text-sm font-medium text-gray-800">
                    Customer User
                  </p>
                  <p className="text-xs text-gray-500">customer@example.com</p>
                </div>
                <button
                  className="w-8 h-8 rounded-full hover:bg-emerald-200 flex items-center justify-center text-gray-500 hover:text-emerald-600 transition-colors duration-200"
                  onClick={handleLogout}
                >
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                    />
                  </svg>
                </button>
              </div> */}

              {/* Help Section */}
              {/* <div className="p-3 mx-3 mb-4">
                <div className="flex items-center space-x-3 p-3 bg-gradient-to-r from-blue-50 to-emerald-50 rounded-lg border border-emerald-100">
                  <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-emerald-500 rounded-full flex items-center justify-center">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-gray-900 truncate">Need Help?</p>
                    <p className="text-xs text-gray-500 truncate">24/7 Support Available</p>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        )}

        {/* Main content */}
        <div className="flex-1">
          <main className={`p-2 ${!isLoginPage ? "mt-16" : ""}`}>
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}
